var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Transition',{attrs:{"name":"slide-fade","appear":""}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.isLoading || _vm.loading),expression:"isLoading || loading"}],staticClass:"my-spinner",class:{
      'has-bg': _vm.hasBg,
    }},[_c('div',{staticClass:"lds-ring"},[_c('div'),_c('div'),_c('div'),_c('div')])])])
}
var staticRenderFns = []

export { render, staticRenderFns }